export function isDocumentResult(result) {
  return (
    result &&
    result.success &&
    result.result &&
    typeof result.result === 'object' &&
    result.result.populatedData &&
    Array.isArray(result.result.populatedData) &&
    result.result.hierarchies &&
    Array.isArray(result.result.hierarchies)
  );
}

export function validateDocumentResult(result) {
  const errors = [];

  if (!result) {
    errors.push('Result is null or undefined');
    return { valid: false, errors };
  }

  if (!result.success) {
    errors.push('Result does not indicate success');
  }

  if (!result.result) {
    errors.push('Result data is missing');
  } else {
    if (typeof result.result !== 'object') {
      errors.push('Result data is not an object');
    }

    if (!result.result.populatedData) {
      errors.push('populatedData is missing from result');
    } else if (!Array.isArray(result.result.populatedData)) {
      errors.push('populatedData is not an array');
    }

    if (!result.result.hierarchies) {
      errors.push('hierarchies is missing from result');
    } else if (!Array.isArray(result.result.hierarchies)) {
      errors.push('hierarchies is not an array');
    }
  }

  return {
    valid: errors.length === 0,
    errors
  };
}

export function hasPopulatedData(result) {
  return (
    isDocumentResult(result) &&
    result.result.populatedData.length > 0
  );
}

export function getPopulatedDataCount(result) {
  if (!isDocumentResult(result)) {
    return 0;
  }

  return result.result.populatedData.length;
}

export function getDocumentPartTypes(result) {
  if (!isDocumentResult(result)) {
    return [];
  }

  const types = new Set();
  result.result.populatedData.forEach(item => {
    if (item.type) {
      types.add(item.type);
    }
  });

  return Array.from(types);
}

export function getPopulatedDataByType(result, type) {
  if (!isDocumentResult(result)) {
    return [];
  }

  return result.result.populatedData.filter(item => item.type === type);
}

export function hasPartType(result, type) {
  return getDocumentPartTypes(result).includes(type);
}
